// extracted by mini-css-extract-plugin
export default {"mainContainer":"CodeReSentNotification_mainContainer__EWBKJ"};